import React from 'react'
import { FormValues } from 'donate/types'
import { FormikCentsProps } from './types'
import { connect } from 'formik'
import { formatCents } from '@betterplace/utils'

export const FormikCents = connect<FormikCentsProps, FormValues>(({ precision, fields, formik }) => {
  // If precision is undefined, the fallback is to who precision 2 if needed and 0 if amount ends with `,00`.
  const cents = fields.reduce((n, field) => n + +(formik.values[field] ?? '0'), 0)
  return <span>{formatCents(i18n.locale, cents, { precision })}</span>
})
